import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FlipSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FlipSVG;
